import { useEffect, useMemo, useState } from "react"
import PaymentProofImageUpload from "./paymentProofImageUpload"
import { useLazyGetAccountantsQuery } from "features/leads/api"
import { RadioButtons, SelectInput } from "components/common"
import { useTranslation } from "react-i18next"
import { localisedValue } from "utils"

export default function DepositSlipSelect(props) {
  const { setFiles, paymentProofProps, setRA = () => {}, project, ...rest } = props
  const { t } = useTranslation()

  const [option, setOption] = useState("self_submit")

  const options = [
    { label: t("Self Submit"), key: "self_submit", id: 1 },
    ...(project?.isRAFlowEnabled ? [{ label: t("By RA"), key: "regional_accountant", id: 2 }] : []),
  ]

  const [getAccountant, { data: accountantData = [], isLoading, isFetching }] = useLazyGetAccountantsQuery()

  useEffect(() => {
    if (option === "regional_accountant") {
      getAccountant(null, true)
    }
  }, [option])

  const getComponent = () => {
    return option === "self_submit" ? (
      <PaymentProofImageUpload
        setFiles={setFiles}
        paymentProofProps={paymentProofProps}
        platformKey={rest?.platformKey}
        projectId={project?.id ?? project?.projectId}
      />
    ) : (
      <SelectInput
        placeholder={t("Choose Accountant")}
        options={accountantData}
        onChange={value => {
          setFiles(value)
        }}
        style={{ minWidth: 120 }}
        inputLoading={isFetching}
      />
    )
  }

  return (
    <>
      <RadioButtons
        className="mbe-16"
        value={option}
        options={options}
        getValue={item => item.key}
        onChange={value => {
          setFiles(null)
          setOption(value.target.value)
          setRA?.(value.target.value)
        }}
      />
      {getComponent()}
    </>
  )
}
